import combineImmutableReducers from 'EmailData/reducers/helpers/combineImmutableReducers';
// @ts-expect-error not migrated to TS yet
// @ts-expect-error not migrated to TS yet
import detailsActionModal from './detailsActionModal';
// @ts-expect-error not migrated to TS yet
import emailChildSelect from './emailChildSelect';
import emailTemplateModeCloneModal from './emailTemplateModeCloneModal';
import hasLaggedStatsTimedOut from './hasLaggedStatsTimedOut';
import hasReachedLimitModalOpen from './hasReachedLimitModalOpen';
import overTimeSelect from './overTimeSelect';
// @ts-expect-error not migrated to TS yet
import sendToMoreLists from './sendToMoreLists';
// @ts-expect-error not migrated to TS yet
import sendToMoreVids from './sendToMoreVids';
// @ts-expect-error not migrated to TS yet
import slack from './slack';
// @ts-expect-error not migrated to TS yet
import testResults from './testResults';
// @ts-expect-error not migrated to TS yet
import smtpPassword from './smtpPassword';
import listLimits from './listLimits';
import portalBotFilterStatus from './portalBotFilterStatus';
export default combineImmutableReducers({
  detailsActionModal,
  emailChildSelect,
  overTimeSelect,
  portalBotFilterStatus,
  sendToMoreVids,
  slack,
  smtpPassword,
  sendToMoreLists,
  hasReachedLimitModalOpen,
  emailTemplateModeCloneModal,
  hasLaggedStatsTimedOut,
  testResults,
  listLimits
});